import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300, // sit above MUI Drawer / sidebar (1200) but below Snackbar
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "12px 12px 12px 16px",
    borderBottom: "1px solid #DADFF6",
    backgroundColor: "#ffffff",
    // Tighten the input padding so the placeholder/text sits close to the
    // search icon adornment instead of the theme's default 16px gap.
    "& .MuiOutlinedInput-root": {
      paddingLeft: 12,
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: 4,
    },
  },
  searchIcon: {
    color: "#8D98C2",
    fontSize: 20,
  },
  closeBtn: {
    flexShrink: 0,
    // Square it with the same 4px corner radius MUI applies to outlined inputs
    // so the close button visually matches the search field next to it.
    width: 48,
    height: 48,
    borderRadius: 4,
    // Light grey from the existing palette so the close affordance is visible
    // even before the user taps it.
    backgroundColor: "#F7F9FF",
    "&:hover": {
      backgroundColor: "#DADFF6",
      opacity: 1,
    },
  },
  body: {
    flex: 1,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
  },
  loaderRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 20px",
  },
  loaderText: {
    color: "#8D98C2",
    fontSize: 14,
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "64px 24px",
    gap: 8,
  },
  emptyIcon: {
    fontSize: 48,
    color: "#DADFF6",
    marginBottom: 8,
  },
  emptyTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#3a4361",
  },
  emptyHint: {
    fontSize: 14,
    color: "#8D98C2",
    maxWidth: 280,
  },
  results: {
    backgroundColor: "#ffffff",
  },
  resultItem: {
    padding: "14px 20px",
    "&:hover": {
      backgroundColor: "#F7F9FF",
    },
  },
  resultName: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1a2240",
  },
  resultMeta: {
    fontSize: 13,
    color: "#8D98C2",
    marginTop: 2,
  },
}));
